import { PlanTemplateType } from "../../templates/generated/template_types";
import type { PlaniraTemplate } from "../../templates/types";
import {
  ModuleDoneType,
  ModuleType,
  PlanQuestionType,
  PlanType,
} from "../../templates/types";

export const PartyTimeTemplate: PlaniraTemplate = {
  planType: PlanType.Planira,
  type: PlanTemplateType.PartyTime,
  title: "Party plan",
  titleHelp: "Our Wedding, Wendy's Birthday party, Anna's Baby shower",
  description: "Organizing a party? Plan every detail effortlessly.",
  longDescription: "",
  emoji: "📅",
  image: require("../../assets/illustrations/bachelorparty-bro.svg"),
  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Party time",
          isDraggable: false,
          emoji: "",
        },
      ],
    },

    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Onboarding,
          title: "When?",
          emoji: "📅",
          questionOption: {
            question: "Do you know when it's happening?",
            questionType: PlanQuestionType.Dates,
          },
        },
        {
          type: ModuleType.Poll,
          doneType: ModuleDoneType.Voting,
          title: "Budget?",
          emoji: "💸",
        },
        {
          type: ModuleType.Expense,
          doneType: ModuleDoneType.None,
          title: "Expenses",
          emoji: "💰",
        },
      ],
    },
  ],
};
